import { useNavigate, useParams } from "react-router";
import { useProfilPlayerStore, useProfilStore } from "../stores/useStore";
import { observer } from "mobx-react-lite";
import Header from "../components/general/Header";
import AnimatedBackground from "../components/general/AnimatedBackground";
import "../style/ProfilPlayer.css";
import { useEffect, useState } from "react";

const ProfilPlayer = observer(() => {
  const profilPlayerStore = useProfilPlayerStore();
  const profilStore = useProfilStore();
  const navigate = useNavigate();
  const { id } = useParams();
  const [profil, setProfil] = useState(null);


  

  useEffect(() => {
    const loadProfil = async () => {
      const loadedProfil = await profilPlayerStore.fetchProfilById(id);
      setProfil(loadedProfil);
      if (profilStore?.isConnected && loadedProfil?.id === profilStore?.id) {
        navigate("/profil");
      }
    };

    loadProfil();
  }, []);
  
 

  return (
    <main className={`profilPlayer_main ${profilStore.profilPicture ? "hasProfilPicture" : ""}`}>
      <Header admin={profilStore.admin} connected={profilStore.isConnected} imageProfil={profilStore.isConnected&&profilStore.profilPicture?profilStore.profilPicture:undefined}/>
      {profil?.theme?<AnimatedBackground className="profilPlayer_animatedCanva" color={profil?.theme.color ? profil?.theme.color : null} />:null}
      {profil?.profilPicture && (
        <img title="Photo de profil" src={profil?.profilPicture} alt="Profil" className="profilPlayer_profilPicture" />
      )}
      <div className="profilPlayer_mainContent">
        <h2 title="Score" className="profilPlayer_score">{profil?.score}</h2>
        <h1 title="Pseudo" className="profilPlayer_pseudo">{profil?.pseudo}</h1>
      </div>
    </main>
  );
});

export default ProfilPlayer;
